import { AudioInputTest, VideoInputTest } from "@twilio/rtc-diagnostics";

export enum ErrorTypes {
  permissions,
}

export interface IDiagnosticsError {
  type: ErrorTypes;
  error: Error;
}

export interface IDiagnosticsState {
  step: number;
  error: IDiagnosticsError | null;
  videoTestReport: VideoInputTest.Report | null;
  audioInputTestReport: AudioInputTest.Report | null;
};
